export class Role {
    private role : string;
    public static admin : string = "admin";
    public static owner : string = "owner";
    public static member : string = "member";
    public static creator : string = "creator";
    public static learner : string = "learner";
    constructor(roleType : string){
        this.role = roleType;
    }

}